"use client";

import { ReactNode, Ref, useContext } from "react";

import { Context } from "../Context/Context";

const NavLink: React.FC<NavLinkProps> = ({ children, navRef, ...props }) => {
  const context = useContext(Context);
  const Component = context?.navLinkComponent;
  if (!Component) {
    return (
      <a ref={navRef} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Component ref={navRef} {...props}>
      {children}
    </Component>
  );
};

export type NavLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  children?: ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  navRef?: Ref<any>;
};

export default NavLink;
